<template>
	<div class="plugin-sync-menu">
		<ModalHeader :title="getString('sync_menu', [userStore.menuWord])" :button-text="getString('sync')" @clickButton="syncMenu" :button-loading="loading" />
		<AppList :items="syncMenuItems" />
	</div>
</template>

<script>
import AppList from "@/shared/components/AppList.vue";
import {useUserStore} from "@/console-new/stores";
import ModalHeader from "@/console-new/components/shared/ModalHeader.vue";
import {useLanguageStore, useNotificationStore} from "@/shared/stores";
import API from "@/shared/helpers/API";

export default {
	setup() {
		const userStore = useUserStore();
		const languageStore = useLanguageStore();
		const notificationStore = useNotificationStore();
		return {
			userStore,
			notificationStore,
			getString: languageStore.getString,
		};
	},
	name: "PluginSyncMenu",
	components: {ModalHeader, AppList},
	emits: ["close"],
	props: {
		pluginId: {type: String, required: true},
	},
	data() {
		return {
			menus: [],
			menuSelectedIndex: null,
			loading: false,
			percentDifference: 0,
			autoAssignSku: true,
		}
	},
	computed: {
		syncMenuItems() {
			return [
				{
					title: this.userStore.menuWord,
					selectValues: this.menus ? this.menus.map(m => {
						return m.name ? m.name : this.getString('no_name');
					}) : [],
					selectedIndex: this.menuSelectedIndex,
					callbackSelect: (newVal) => {
						this.menuSelectedIndex = newVal;
					}
				},
				{
					title: this.getString("price_percent_difference"),
					numberInput: true,
					value: this.percentDifference,
					symbol: "%",
					rightSymbol: true,
					min: -100,
					max: 100,
					callbackNumber: (newVal) => {
						this.percentDifference = newVal;
					},
					explain: this.getString("price_percent_difference_explain"),
				},
				{
					title: this.getString("auto_assign_sku"),
					active: this.autoAssignSku,
					switch: true,
					callback: (item, newVal) => {
						this.autoAssignSku = newVal;
					},
					explain: this.getString("auto_assign_sku_explain"),
				},
			];
		}
	},
	methods: {
		refreshMenus() {
			API.init().getMenus(this.userStore.currBusinessId, (response) => {
				if (response && response.result === "OK" && response.menus) {
					this.menus = response.menus;
					if(this.menus.length > 0) {
						this.menuSelectedIndex = 0;
					}
				}
			});
		},
		syncMenu() {
			if(this.menuSelectedIndex !== null) {
				this.loading = true;
				const fromMenu = this.menus[this.menuSelectedIndex];
				API.init().syncMenu(this.userStore.currBusinessId, this.pluginId, fromMenu.menu_id, this.percentDifference, this.autoAssignSku, (response) => {
					this.loading = false;
					if (response && response.result === "OK") {
						this.$emit("close");
						this.notificationStore.showNotification("generic-success");
					} else {
						this.notificationStore.showNotification("generic-fail");
					}
				});
			}
		}
	},
	mounted() {
		this.refreshMenus();
	},
}
</script>

<style scoped lang="scss">

</style>